import Vue from "vue";
import RoutePathEnum from "../../enums/RoutePathEnum";
import router from "../../js/router";
import UrlMap from "../../js/slug-to-url-map";

const accessTokenKey = 'accessToken';

export default class AuthService {

    static login(data) {
        let accessToken = data.accessToken ?? '';
        let expiresIn = data.expiresIn ?? 0;

        if (accessToken.length > 0 && expiresIn > 0) {
            Vue.$cookies.set(accessTokenKey, accessToken, expiresIn, null, process.env.VUE_APP_HOST);
        }
    }

    static logout() {
        Vue.$api.logout().then(() => {
                this.revokeAccessToken()
                router.push(RoutePathEnum.LOGIN);
            }
        )
    }

    static getAccessToken() {
        return Vue.$cookies.get(accessTokenKey);
    }

    static revokeAccessToken() {
        Vue.$cookies.remove(accessTokenKey, null, process.env.VUE_APP_HOST);
        Vue.$cookies.remove(accessTokenKey);
    }

    static isLogged() {
        return Vue.$cookies.isKey(accessTokenKey);
    }

    static redirectUserToTheOldAppOrDashboard() {
        this.loadingState = true;
        Vue.$api.authenticatedInit()
            .then(({data}) => {
                this.loadingState = true;

                let access = data.user.accesses.filter(x => x.hasAccess === true);

                if (access.length !== 1) {
                    this.goToTheDashboard();
                    return;
                }

                let appSlug = access[0].appSlug;
                if (appSlug in UrlMap) {
                    window.location = UrlMap[appSlug];
                    return;
                }
                this.goToTheDashboard();
            }).catch(() => {
            this.goToTheDashboard();
        }).finally(() => {
            this.loadingState = false;
        });
    }

    static goToTheDashboard() {
        /* Delay for setting cookies */
        setTimeout(() => {
            router.push(RoutePathEnum.DASHBOARD);
        }, 10);
    }
}